import React from "react";
import "../styles/MobileFooter.css";

const MobileFooter = (props) => {
  return (
    <div className="mobile-footer">
      <div
        className={`mobile-footer-icon ${
          props.activeComponent === "My Rewards" ? "active" : ""
        }`}
        onClick={() => props.setActiveComponent("My Rewards")}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24"
          viewBox="0 -960 960 960"
          width="24"
        >
          <path d="M287.694-535.386 480-850.767l192.306 315.381H287.694ZM700-95.386q-68.846 0-116.73-47.884T535.386-260q0-68.846 47.884-116.73T700-424.614q68.846 0 116.73 47.884T864.614-260q0 68.846-47.884 116.73T700-95.386Zm-564.614-20v-289.228h289.228v289.228H135.386Zm564.603-39.998q43.934 0 74.28-30.336 30.347-30.335 30.347-74.269 0-43.934-30.336-74.28-30.335-30.347-74.269-30.347-43.934 0-74.28 30.336-30.347 30.335-30.347 74.269 0 43.934 30.336 74.28 30.335 30.347 74.269 30.347Zm-504.605-20h169.232v-169.232H195.384v169.232Zm198.154-420h172.924L480-734.462l-86.462 139.078Zm86.462 0ZM364.616-344.616ZM700-260Z" />
        </svg>
        <div className="mobile-footer-text">My Rewards</div>
      </div>
      <div
        className={`mobile-footer-icon ${
          props.activeComponent === "Collections" ? "active" : ""
        }`}
        onClick={() => props.setActiveComponent("Collections")}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24"
          viewBox="0 -960 960 960"
          width="24"
        >
          <path d="M400-410.001h149.615v-59.998H400v59.998Zm0-120h299.229v-59.998H400v59.998Zm0-120h299.229v-59.998H400v59.998Zm-77.692 390q-30.308 0-51.307-21-21-21-21-51.308v-455.382q0-30.308 21-51.308 20.999-21 51.307-21h455.383q30.307 0 51.307 21 21 21 21 51.308v455.382q0 30.308-21 51.308t-51.307 21H322.308Zm0-59.999h455.383q4.615 0 8.462-3.846 3.846-3.847 3.846-8.463v-455.382q0-4.616-3.846-8.463-3.847-3.846-8.462-3.846H322.308q-4.616 0-8.462 3.846-3.847 3.847-3.847 8.463v455.382q0 4.616 3.847 8.463 3.846 3.846 8.462 3.846ZM182.309-120.003q-30.307 0-51.307-21-21-21-21-51.307v-515.381h59.999v515.381q0 4.616 3.846 8.462 3.847 3.847 8.462 3.847h515.382v59.998H182.309ZM309.999-800v480-480Z" />
        </svg>
        <div className="mobile-footer-text">Collection</div>
      </div>
      <div
        className={`mobile-footer-icon ${
          props.activeComponent === "Scan" ? "" : ""
        }`}
        onClick={() => props.setShowScanTicketComponent(true)}
      >
        <div className="scan-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="24"
          >
            <path d="M90-730.001v-179.998H270v59.998h-120v120H90.001Zm720.001 0v-120h-120v-59.998h179.998v179.998h-59.998Zm-720 680v-179.998h59.998v120h120v59.998H90.001Zm600 0v-59.998h120v-120h59.998v179.998H690.001ZM269.999-242.308q0 4.616 3.847 8.462 3.846 3.847 8.462 3.847h395.384q4.616 0 8.462-3.847 3.847-3.846 3.847-8.462v-475.384q0-4.616-3.847-8.462-3.846-3.847-8.462-3.847H282.308q-4.616 0-8.462 3.847-3.847 3.846-3.847 8.462v475.384Zm12.309 72.307q-30.308 0-51.307-21-21-20.999-21-51.307v-475.384q0-30.308 21-51.307 20.999-21 51.307-21h395.384q30.308 0 51.307 21 21 20.999 21 51.307v475.384q0 30.308-21 51.307-20.999 21-51.307 21H282.308Zm87.693-400h219.998v-59.998H370.001v59.998Zm0 120h219.998v-59.998H370.001v59.998Zm0 120h219.998v-59.998H370.001v59.998Zm-100.002 87.693v-487.693 500.002-12.309Z" />
          </svg>
        </div>
        <div className="mobile-footer-text">Scan</div>
      </div>
      <div
        className={`mobile-footer-icon ${
          props.activeComponent === "Rank" ? "active" : ""
        }`}
        onClick={() => props.setActiveComponent("Rank")}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24"
          viewBox="0 -960 960 960"
          width="24"
        >
          <path d="m354-247 126-76 126 77-33-144 111-96-146-13-58-136-58 135-146 13 111 97-33 143Zm-90.998 125.458 57.307-246.766L128.85-534.23l252.613-21.922L480-788.842l98.537 232.69L831.15-534.23 639.691-368.308l57.307 246.766L480-252.463 263.002-121.542ZM480-430Z" />
        </svg>
        <div className="mobile-footer-text">Rank</div>
      </div>
      <div
        className={`mobile-footer-icon ${
          props.activeComponent === "Profile" ? "active" : ""
        }`}
        onClick={() => props.setActiveComponent("Profile")}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24"
          viewBox="0 -960 960 960"
          width="24"
        >
          <path d="M480-492.309q-57.749 0-98.874-41.124-41.125-41.125-41.125-98.874 0-57.75 41.125-98.874 41.125-41.125 98.874-41.125 57.749 0 98.874 41.125 41.125 41.124 41.125 98.874 0 57.749-41.125 98.874-41.125 41.124-98.874 41.124ZM180.001-187.694v-88.922q0-29.384 15.962-54.422 15.961-25.038 42.653-38.5 59.308-29.077 119.654-43.615T480-427.691q61.384 0 121.73 14.538 60.346 14.538 119.654 43.615 26.692 13.462 42.653 38.5 15.962 25.038 15.962 54.422v88.922H180.001ZM240-247.693h480v-28.923q0-12.154-7.039-22.5-7.038-10.346-19.115-16.885-51.692-25.461-105.418-38.577Q534.702-367.693 480-367.693t-108.428 13.115q-53.726 13.116-105.418 38.577-12.077 6.539-19.115 16.885Q240-288.77 240-276.616v28.923Zm240-304.614q33 0 56.5-23.5t23.5-56.5q0-33-23.5-56.5t-56.5-23.5q-33 0-56.5 23.5t-23.5 56.5q0 33 23.5 56.5t56.5 23.5Zm0-80Zm0 384.614Z" />
        </svg>
        <div className="mobile-footer-text">Profile</div>
      </div>
    </div>
  );
};

export default MobileFooter;
